import { render, staticRenderFns } from "./DialogInstructionsElement.vue?vue&type=template&id=fce024d0&scoped=true&lang=pug"
import script from "./DialogInstructionsElement.vue?vue&type=script&lang=js"
export * from "./DialogInstructionsElement.vue?vue&type=script&lang=js"
import style0 from "./DialogInstructionsElement.vue?vue&type=style&index=0&id=fce024d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce024d0",
  null
  
)

export default component.exports